import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

const ScrollToTop = ({ history }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      // te ensucio el código por acá jajaja
      const headerGroup = document.querySelector('.header-item-group')
      const navbar = document.querySelector('.navbar')
      if (headerGroup && navbar && headerGroup.classList.contains('active')) {
        navbar.classList.toggle('nav-open')
        headerGroup.classList.toggle('active')
      }
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
    return () => {
      unlisten()
    }
  }, [history])

  return null
}

export default withRouter(ScrollToTop)
